module.exports = __webpack_public_path__ + "img/cherokee.4aa66cc9.png";